export default __webpack_public_path__ + "./images/dm.9ce72535.png";